import React, { FC, useState, useContext, useCallback, useEffect } from 'react';

const OnlineStatusContext = React.createContext({
  isOnline: true,
});

type Props = {
  children: JSX.Element;
};

export const OnlineStatusProvider: FC<Props> = ({ children }) => {
  const [onlineStatus, setOnlineStatus] = useState<boolean>(true);

  const value = {
    isOnline: onlineStatus,
  };

  const goOnline = useCallback(() => {
    console.warn('App online');
    setOnlineStatus(true);
  }, []);

  const goOffline = useCallback(() => {
    console.warn('App offline');
    setOnlineStatus(false);
  }, []);

  useEffect(() => {
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  });

  return <OnlineStatusContext.Provider value={value}>{children}</OnlineStatusContext.Provider>;
};

export const useOnlineStatus = () => {
  const store = useContext(OnlineStatusContext);
  return store;
};

type OnlineProps = {
  children: React.ReactNode;
  showIfOffline?: boolean;
};

export const Online: FC<OnlineProps> = ({ children, showIfOffline }) => {
  const onlineStatus = useOnlineStatus();
  const show = showIfOffline === true || onlineStatus.isOnline;
  return show ? <>{children}</> : <></>;
};
